import customAxios from "./axiosConfig";

const InvoicePaymentsService = {
  list (params) {
    const api_url = window.Urls['invoicepayment-list']()
    return customAxios.get(api_url, { params: params })
  },
  create (invoice_payment) {
    invoice_payment.amount = parseFloat(invoice_payment.amount).toFixed(2).toString()
    const api_url = window.Urls['invoicepayment-list']()
    return customAxios.post(api_url, invoice_payment)
  },
  update (invoice_payment_id, data) {
    const api_url = window.Urls['invoicepayment-detail'](invoice_payment_id)
    return customAxios.put(api_url, data)
  },
  destroy (invoice_payment_id) {
    const api_url = window.Urls['invoicepayment-detail'](invoice_payment_id)
    return customAxios.delete(api_url)
  },
  partial_update (invoice_payment) {
    const api_url = window.Urls['invoicepayment-detail'](invoice_payment.id)
    return customAxios.patch(api_url, invoice_payment)
  },
  total (params) {
    const api_url  = window.Urls['invoicepayment-total']()
    return customAxios.get(api_url, { params: params })
  },
  retrieveInvoice (invoice_id) {
    const api_url = window.Urls['invoicepayment-invoice'](invoice_id)
    return customAxios.get(api_url)
  }
}

export default InvoicePaymentsService;
